<template>
  <ZMainPage type="card">
    <div class="z-box-bg top-info mb-3">
      <div class="top-info-item" v-for="item in list0" :key="item.label">
        <div class="top-info-label">{{ item.label }}</div>
        <div class="top-info-value">
          <span :class="item.class">{{ item.value }}</span>
          <span class="text-primary ml-2 c-p" v-if="item.button" @click="handleView">{{ item.button }}</span>
        </div>
      </div>
    </div>
    <div class="bg-white mt-2">
      <Tabs :index.sync="index" :list="['报名信息', '学生高考成绩', '备注信息']" :cssStyle="{ fontSize: '20rem', padding: '0 20rem' }"></Tabs>
    </div>
    <div class="z-box-bg" v-if="index === 0">
      <LineWrapper class="list1" label-width="130rem">
        <LineItem :label="item.label" v-for="item in list1" :key="item.label">
          <span>{{ item.value }}</span>
          <span class="text-primary ml-1 c-p" v-if="item.button">{{ item.button }}</span>
        </LineItem>
      </LineWrapper>
    </div>
    <div v-else-if="index === 1">
      <div class="z-box-bg">
        <DetailTable v-if="tableData.length" border :data="tableData" :config="tableConfig"></DetailTable>
        <t-result type='empty' v-else></t-result>
      </div>
    </div>
    <div class="z-box-bg" v-else-if="index === 2">
      <template v-if="list2.length">
          <div class="list2" v-for="item in list2" :key="item.id">
          <div class="title">{{ item.label }}</div>
          <div class="content">{{ item.value }}</div>
        </div>
      </template>
      <t-result type='empty' v-else></t-result>
    </div>
    <Dialog :visible.sync="visible" title="学生身心情况" size="small" :loading="loading" submitText="我知道了" titleAlign="center" buttonAlign="center" :showCancelButton="false" :showClose="false" :closeOnClickModal="false">
      <LineWrapper label-width="100rem" class="flex flex-column align-center" labelColor="#3c3c3c" :valueStyle="{fontWeight: 600}">
        <LineItem :label="item.label" :value="item.value" v-for="item in dialogList" :key="item.label" style="width: 300rem;"></LineItem>
      </LineWrapper>
    </Dialog>
    <template #footer>
      <el-button type="primary" @click="$router.back()">返回</el-button>
    </template>
  </ZMainPage>
</template>

<script>
import Dialog from "@/components/common/Dialog"
import Tabs from "@/components/common/Tabs"
import LineWrapper from "@/components/common/LineWrapper"
import LineItem from "@/components/common/LineItem"
import DetailTable from "@/components/common/DetailTable"
import http from '@/api'
import { orderStatusColor } from '@/utils/data'
export default {
	_config:{"route":{"path":"detail","meta":{"title":"详情"}}},
  components: { Dialog, Tabs, LineWrapper, LineItem, DetailTable },
  data() {
    return {
      visible: false,
      loading: false,
      index: 0,
      list0: [],
      list1: [],
      list2: [],
      tableData: [],
      tableConfig: [],
      dialogList: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      http({ url: '/recruit/fresh-graduate/details-anew-v2', pre: 'zs' }, { order_id: this.$route.query.id }).then(res => {
        // 顶部展示
        const { student_health: { crime_text, physiology, psychology }, regist_info: info, senior_score: score, remark_list = [] } = res
        this.list0 = [
          { label: '订单状态', value: res.order_status, class: orderStatusColor[res.order_status] },
          { label: '学生姓名', value: res.student_name },
          { label: '性别', value: res.sex },
          { label: '家长姓名', value: res.parent_name },
          { label: '家长和学生的关系', value: res.relationship_name },
          { label: '是否可招收', value: res.recruit, button: `${res.recruit === '可招收' ? '查看详情' : ''}`, type: 1 }
        ]
        this.dialogList = [
          { label: '身体疾病', value: physiology },
          { label: '心理疾病', value: psychology },
          { label: '犯罪记录', value: crime_text },
        ]
        // 报名信息
        this.list1 = [
          { label: '报名就读学校', value: info.school },
          { label: '实际就读学校', value: info.reality_school },
          { label: '学生户籍地', value: info.student_register_address_name || '-' },
          { label: '学生当前状态', value: info.student_status },
          { label: '所属业务线', value: info.business_type || '普通复读生' },
          { label: '报名年级', value: info.grade_name },
          { label: '当前客户归属人', value: info.belong_teacher || '-' },
          { label: '报名招生老师', value: info.sign_teacher || '-'  },
          { label: '订单号', value: info.order_number },
          { label: '创建订单时间', value: info.order_created_at },
          { label: '支付金额', value: info.money_actual }
        ]
        // 学生高考成绩
        const { junior_score = [] } = score
        this.tableConfig = junior_score.map((i, j) => ({ label: i.subject_name, prop: 'prop' + (i.subject_id || j + 1) }))
        let obj = {}
        junior_score.map((i, j) => {
          const { subject_level = {}, subject_id } = i
          obj['prop' + (subject_id || j + 1)] = subject_level.level || subject_level.score
        })
        if (junior_score.length) {
          this.tableData = [obj]
        }
        // 备注信息
        this.list2 = remark_list.map(i => ({ id: i.id, label: `${i.creator} 在 ${i.created_at} 提交了备注`, value: i.content }))
      }).finally(() => this.loading = false)
    },
    handleView() {
      this.visible = true
    },
  }
}
</script>

<style lang="scss" scoped>
.top-info {
  display: flex;
  flex-wrap: wrap;
  gap: 20rem;
  &-item {
    max-width: 240rem;
    margin-right: 80rem;
    font-size: 15rem;
    line-height: 32rem;
    display: flex;
    flex-shrink: 0;
  }
  &-label {
    margin-right: 30rem;
  }
  &-value {
    font-weight: 600;
  }
}
.list1 {
  display: grid;
  gap: 10rem 20rem;
  grid-template-columns: repeat(auto-fill, minmax(380rem, 1fr));
}
.list2 {
  .title {
    font-size: 18rem;
    margin-bottom: 16rem;
  }
  .content {
    min-height: 100rem;
    margin-bottom: 30rem;
    padding: 18rem 16rem;
    font-size: 16rem;
    color: #888;
    border-radius: 8rem;
    background-color: #FBFCFC;
  }
}
.page-title {
  padding-left: 20rem;
  margin-bottom: 10rem;
  font-size: 20rem;
  font-weight: 600;
  line-height: 1.8;
}
</style>
